import { Shape } from '../types';
import { DisplayObject } from './DisplayObject';

/**
 * 节点片段，用于包裹多个节点并批量操作
 *
 *  向 Fragment 或者根节点为 Fragment 的节点添加子节点时，不会触发渲染和事件。
 *
 * 当 Fragment 被挂载到 Canvas 中的节点时，其子节点会一次性被渲染，并触发合并事件。
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DocumentFragment
 */
export class Fragment extends DisplayObject {
  constructor() {
    super({ type: Shape.FRAGMENT });
  }
}
